import { useCallback, useEffect, useRef, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { debounceMs, minQueryLength } from './constants'

const useCodeSearch = (serviceFn, initialValue) => {
  const { data, loading, fetchData } = useFetch(serviceFn, { doInitialRequest: false })
  const [selectedDescription, setSelectedDescription] = useState('')
  const debounceRef = useRef(null)
  const lastFetchedValueRef = useRef(null)

  useEffect(() => {
    if (!initialValue || lastFetchedValueRef.current === initialValue) return
    lastFetchedValueRef.current = initialValue
    fetchData({ query: initialValue })
  }, [initialValue, fetchData])

  useEffect(() => {
    if (!initialValue || !data) return
    const match = data.find(item => item.code === initialValue)
    setSelectedDescription(match?.description || '')
  }, [data, initialValue])

  const handleSelect = useCallback(
    code => {
      const match = (data || []).find(item => item.code === code)
      setSelectedDescription(match?.description || '')
    },
    [data]
  )

  const handleSearchChange = useCallback(
    query => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current)
      }

      if (!query || query.length < minQueryLength) {
        return
      }

      debounceRef.current = setTimeout(() => {
        fetchData({ query })
      }, debounceMs)
    },
    [fetchData]
  )

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current)
      }
    }
  }, [])

  return { items: data || [], loading, selectedDescription, handleSearchChange, handleSelect }
}

export default useCodeSearch
